"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

require("core-js/modules/es.array.join.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.promise.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

require("regenerator-runtime/runtime.js");

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = require("react");

var _notification = _interopRequireDefault(require("antd/lib/notification"));

var _link = require("@meepshop/link");

var _locales = require("@meepshop/locales");

var _useFbLogin = _interopRequireDefault(require("./useFbLogin"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

// definition
var _default = function _default(appId, version) {
  var _useTranslation = (0, _locales.useTranslation)('fb'),
      t = _useTranslation.t;

  var router = (0, _link.useRouter)();

  var _useState = (0, _react.useState)(null),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      fb = _useState2[0],
      setFb = _useState2[1];

  var asPathRef = (0, _react.useRef)(router.asPath);
  var fbLogin = (0, _useFbLogin["default"])();
  (0, _react.useEffect)(function () {
    asPathRef.current = router.asPath;
  }, [router.asPath]);
  return {
    fb: fb,
    onLoad: (0, _react.useCallback)(function () {
      var render = function render() {
        var windowFB = window.FB; // FIXME: remove once T12090 or FB login button issue has been resolved
        // window.FB.Event.unsubscribe('xfbml.render', render);

        setFb(_objectSpread(_objectSpread({}, windowFB), {}, {
          login: function login(redirectPath) {
            return new Promise(function (resolve) {
              if (/(Line|Instagram|FBAN|FBAV)/gm.test(window.navigator.userAgent)) router.push(["https://www.facebook.com/".concat(version, "/dialog/oauth?"), "client_id=".concat(appId), "redirect_uri=https://".concat(router.domain, "/fb-login"), "scope=email", "state=".concat(redirectPath || asPathRef.current), "response_type=token"].join('&'));else windowFB.login( /*#__PURE__*/function () {
                var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(_ref) {
                  var status, authResponse;
                  return _regenerator["default"].wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          status = _ref.status, authResponse = _ref.authResponse;

                          if (!(status !== 'connected')) {
                            _context.next = 5;
                            break;
                          }

                          _notification["default"].error({
                            message: t('login-fail'),
                            description: t('login-fail-description')
                          });

                          _context.next = 7;
                          break;

                        case 5:
                          _context.next = 7;
                          return fbLogin(authResponse.accessToken, redirectPath);

                        case 7:
                          resolve();

                        case 8:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                }));

                return function (_x) {
                  return _ref2.apply(this, arguments);
                };
              }(), {
                scope: 'public_profile,email'
              });
            });
          }
        }));
      };

      window.fbAsyncInit = function () {
        window.FB.init({
          appId: appId,
          cookie: true,
          xfbml: true,
          version: version
        });
        render(); // FIXME: remove once T12090 or FB login button issue has been resolved
        // window.FB.Event.subscribe('xfbml.render', render);
      };
    }, [appId, fbLogin, router, t, version])
  };
};

exports["default"] = _default;